(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelector('.footer-menu .open-menu').addEventListener("click", function(e) {
    e.preventDefault();
    openMainMenu();
  });

  function openMainMenu() {
    var header = document.getElementsByClassName('shopify-section-header-sticky')[0];
    document.querySelector('.header__icon--menu').click();
    header.classList.add('header--open');
  }

  const links = document.querySelectorAll('.footer-block--menu .footer-block__heading');

  links.forEach(link => {
    link.addEventListener('click', function handleClick(event) {
      event.preventDefault();
      const menu = link.nextSibling;
  
      if (window.getComputedStyle(menu).display === "none") {
        menu.style.display = "block";
      } else {
        menu.style.display = "none";
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  //CUSTOM 
  
  var header = document.getElementsByClassName('shopify-section-header-sticky')[0];
  
  document.querySelector('.header__icon--menu span .icon-hamburger').addEventListener("click", function(e) {
    header.classList.add('header--open');
  });

  document.querySelector('.header__icon--menu span .icon-close').addEventListener("click", function(e) {
    header.classList.remove('header--open');
  });
  
  var scrollPosition = window.scrollY;
  
  
  window.addEventListener('scroll', function() {
      scrollPosition = window.scrollY;
  
      if (scrollPosition >= header.offsetHeight) {
          header.classList.add('header--scrolled');
      } else {
          header.classList.remove('header--scrolled');
      }
  });

  var megaMenu = document.getElementsByClassName('mega-menu')[0];

  megaMenu.addEventListener('click', function (event) {
    // header.classList.toggle('header--open');
    window.location.href = "/collections/all"
  });

  let items = document
      .querySelector(".header__inline-menu")
      .querySelectorAll("details");

  items.forEach((item) => {
      item.addEventListener("mouseover", () => {
          item.setAttribute("open", true);
          item.querySelector("summary").setAttribute("aria-expanded", "true");
          header.classList.add('header--open');
          item.addEventListener("mouseout", () => {
              item.removeAttribute("open");
              item.querySelector("summary").setAttribute("aria-expanded", "false");
              header.classList.remove('header--open');
          });
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !window.DesignMode) return;
  try {
    
  const banners = document.querySelectorAll(".banner");

  if (banners.length) {
    for (const banner of banners) {
      const bannerIcon = banner.querySelector("#banner-icon");
      if (bannerIcon) bannerIcon.addEventListener("click", function() { bannerScrollDown(banner.parentNode) });
    }
  }

  function bannerScrollDown(el) {
    const offsetTop = el.nextElementSibling.offsetTop;
  
    scroll({
      top: offsetTop,
      behavior: "smooth"
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const gridView = document.getElementById('grid-view-container');
    const listView = document.getElementById('list-view-container');
    const toggleButtons = document.querySelectorAll('.view-toggle');
    const listContainer = document.getElementById('list-view-items');
  
    let articles = window.blogArticles;
    let currentSort = { key: 'date', order: 'desc' };
  
    function setView(view) {
      if (view === 'list') {
        gridView.setAttribute('hidden', '');
        listView.removeAttribute('hidden');
        renderList(articles); // render list only when list is visible
      } else {
        listView.setAttribute('hidden', '');
        gridView.removeAttribute('hidden');
      }
  
      toggleButtons.forEach(btn =>
        btn.classList.toggle('active', btn.dataset.view === view)
      );
  
      localStorage.setItem('blogView', view);
    }
  
    function renderList(data) {
      if (!listContainer) return;
  
      listContainer.innerHTML = '';
  
      data.forEach(article => {
        const html = `
          <div class="list-card-wrapper">
            <div class="blog-articles__article article">
              <a href="${article.url}">
                <div class="article-card-list">
                  <div>
                    ${article.image ? `
                      <div class="card-list__image-wrap">
                        <img src="${article.image}" alt="${article.imageAlt || ''}" loading="lazy" />
                      </div>` : ''}
                  </div>
                  <div>
                    <p>${new Date(article.date).toLocaleDateString('en-GB', { month: 'long', year: 'numeric' })}</p>
                  </div>
                  <div>
                    ${article.client ? `<p class="article-card__client">${article.client}</p>` : ''}
                  </div>                  
                  <div>
                    <h3>${article.project}</h3>
                  </div>
                  <div>
                    ${article.type ? `<p class="article-card__type">${article.type}</p>` : ''}
                  </div>
                  <div>
                    <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
                    </svg>
                  </div>
                </div>
              </a>
            </div>
          </div>
        `;
        listContainer.insertAdjacentHTML('beforeend', html);
      });
    }
  
    function sortList(key) {
      const order = (currentSort.key === key && currentSort.order === 'asc') ? 'desc' : 'asc';
      currentSort = { key, order };
  
      articles.sort((a, b) => {
        const valA = (a[key] || '').toLowerCase ? (a[key] || '').toLowerCase() : a[key];
        const valB = (b[key] || '').toLowerCase ? (b[key] || '').toLowerCase() : b[key];
  
        if (valA < valB) return order === 'asc' ? -1 : 1;
        if (valA > valB) return order === 'asc' ? 1 : -1;
        return 0;
      });
  
      renderList(articles);
    }
  
    // Attach sort buttons
    document.querySelectorAll('[data-sort]').forEach(button => {
      button.addEventListener('click', () => {
        const key = button.dataset.sort;
        sortList(key);
      });
    });
  
    // Toggle view on button click
    toggleButtons.forEach(button => {
      button.addEventListener('click', () => {
        setView(button.dataset.view);
      });
    });
  
    // Initial load
    const savedView = localStorage.getItem('blogView') || 'grid';
    setView(savedView);
  
    document.querySelectorAll('[data-toggle="card"]').forEach(card => {
      card.addEventListener('click', (e) => {
        if (e.target.closest('a')) return;
        const id = card.dataset.id;
        const content = document.getElementById(`Reveal-${id}`);
        if (content) {
          content.hidden = !content.hidden;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
